import { entryLinks, heroSideFlashes, quickNews } from "@/mocks/homeData";

export default function HeroSection() {
  return (
    <section id="top" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto grid w-full max-w-shell grid-cols-1 gap-10 px-4 pb-10 pt-12 md:px-6 md:pb-14 md:pt-16 lg:grid-cols-12 lg:gap-14 lg:px-8">
        <div className="lg:col-span-7">
          <span className="rise-in inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 font-label text-xs text-primary-700">
            <i className="ri-record-circle-line" />
            黑料网1 · 今日更新已上线
          </span>

          <h2 className="rise-in rise-in-1 mt-6 font-heading text-3xl font-bold leading-[1.25] tracking-tight text-foreground-950 md:text-5xl md:leading-[1.2]">
            今天刚出的新料，
            <br />
            趁热看才不算错过
          </h2>

          <p className="rise-in rise-in-2 mt-6 max-w-xl font-body text-base leading-relaxed text-foreground-600 md:text-lg">
            黑料网1 最新更新实时滚动，今日头条与快讯同步上线，新料第一时间整理成专题。蹲最新进展、看今日热搜，
            来黑料网1更新页就能抓到刚出的瓜。
          </p>

          <div className="rise-in rise-in-3 mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#headlines"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line" />
              先看今日头条
            </a>
            <a
              href="#updates"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-transparent px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-foreground-950 hover:bg-background-100"
            >
              <i className="ri-history-line" />
              打开最新更新
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
            <div>
              <dt className="font-label text-xs tracking-wider text-foreground-500">今日更新</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">126</dd>
            </div>
            <div>
              <dt className="font-label text-xs tracking-wider text-foreground-500">进行中专题</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">9</dd>
            </div>
            <div>
              <dt className="font-label text-xs tracking-wider text-foreground-500">平均整理用时</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-accent-600">24 分</dd>
            </div>
          </dl>
        </div>

        <aside className="lg:col-span-5">
          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg font-semibold text-foreground-950">正在发生</h3>
              <span className="flex items-center gap-1.5 font-label text-xs text-primary-600">
                <i className="ri-broadcast-line" />
                实时
              </span>
            </div>
            <ul className="mt-5 flex flex-col gap-4">
              {heroSideFlashes.map((item) => (
                <li key={item.time} className="flex gap-4">
                  <span className="mt-0.5 flex h-6 w-14 shrink-0 items-center justify-center rounded bg-background-50 font-label text-[11px] text-foreground-600">
                    {item.time}
                  </span>
                  <p className="font-body text-sm leading-relaxed text-foreground-700">{item.text}</p>
                </li>
              ))}
            </ul>
            <a
              href="#updates"
              className="mt-6 flex cursor-pointer items-center justify-between rounded-md bg-background-50 px-4 py-3 font-label text-sm text-foreground-800 transition-colors hover:text-primary-600"
            >
              查看全部今日更新
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </aside>
      </div>

      <div className="w-full border-t border-background-200 bg-foreground-950">
        <div className="mx-auto flex w-full max-w-shell items-center gap-4 px-4 py-3 md:px-6 lg:px-8">
          <span className="flex shrink-0 items-center gap-2 font-label text-xs text-accent-400">
            <i className="ri-flashlight-fill" />
            新料快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-marquee flex w-max items-center gap-10">
              {[...quickNews, ...quickNews].map((item, index) => (
                <span
                  key={`${item}-${index}`}
                  className="whitespace-nowrap font-body text-sm text-background-200"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto w-full max-w-shell px-4 py-10 md:px-6 md:py-12 lg:px-8">
        <div className="mb-5 flex items-center gap-3">
          <h3 className="font-heading text-lg font-semibold text-foreground-950">快捷入口</h3>
          <span className="h-px flex-1 bg-background-200" />
          <span className="font-label text-xs text-foreground-500">按题材直接进</span>
        </div>
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
          {entryLinks.map((entry) => (
            <a
              key={entry.label}
              href="#topics"
              className="group flex cursor-pointer flex-col gap-2 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-lg text-primary-600 transition-colors group-hover:bg-primary-100">
                <i className={entry.icon} />
              </span>
              <span className="font-label text-sm font-medium text-foreground-900">{entry.label}</span>
              <span className="font-body text-xs text-foreground-500">{entry.desc}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}